/**
 * «Похожие на сцену» в окне «Добавить платье»: типы ответа `GET /api/photos/similar` и чистые помощники.
 * Вызов ручки — `searchDressesByScene` в `lib/photos.ts`: здесь без импортов, модуль грузит `node --test`.
 */
export type SceneRef = { kind: "ref" | "pin"; id: number; thumb: string | null; title: string };
export type DressSimilar = { dresses: { dress_id: number; score: number; photo_id: number }[]; missing: number };

/** `"ref:5"` / `"pin:176"` — значение `select` сцены. */
export const sceneKey = (s: SceneRef): string => `${s.kind}:${s.id}`;

/** Платья с баллом — по убыванию, без балла — в конце в исходном порядке; `null` — как есть. Вход не меняется. */
export function orderDresses<T extends { id: number }>(
  items: readonly T[],
  scores: ReadonlyMap<number, number> | null,
): T[] {
  if (scores === null) return [...items];
  const scored = items.filter((x) => scores.has(x.id)).sort((a, b) => scores.get(b.id)! - scores.get(a.id)!);
  return [...scored, ...items.filter((x) => !scores.has(x.id))];
}
